import { Box } from '@withjoy/joykit';
import React from 'react';
import { Champagne } from '../ImagineYourCardRoot/loader/ChampagneBubbleLoader';

export const CardLoadingAnimation = () => {
  return (
    <Box
      position="absolute"
      inset="0"
      zIndex={-2}
    >
      <Champagne />
    </Box>
  );
};
